import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {faTriangleExclamation, faXmark, faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import {SystemManagementService} from "../../../data-access/system-management.service";
import * as url from "url";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
interface SystemBranding {
  primary_color: string,
  banner_url: string,
  favicon_url: string,
  login_logo_url: string
  login_background_url: string
}
@Component({
    selector: 'system-branding',
    templateUrl: './system-branding.component.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class SystemBrandingComponent implements OnInit {
  systemService = inject(SystemManagementService)
  router = inject(Router)
  _snackBar = inject(MatSnackBar)
  primaryColor = ''
  bannerUrl = ''
  faviconUrl = ''
  loginLogoUrl = ''
  loginBackgroundUrl = ''
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }]
  ngOnInit() {
    this.systemService.getGlobalBranding().subscribe((response) => {
      if(response.success) {
        this.primaryColor = response.result.primary_color
        this.bannerUrl = response.result.banner_url
        this.faviconUrl = response.result.favicon_url
        this.loginLogoUrl = response.result.login_logo_url
        this.loginBackgroundUrl = response.result.login_background_url
        // TODO to use local storage I will need to account for the local storage being cleared and values being null
        localStorage.setItem('primaryColor', this.primaryColor)
        // TODO need to change these values in the system
      } else {

      }
    })
  }

  systemManagementMenu() {
    this.router.navigate(['dashboard/SystemManagement'])
  }

  saveBranding() {
    // TODO double check if there are anymore things needed for branding
    const json: SystemBranding = {
      primary_color: this.primaryColor,
      banner_url: this.bannerUrl,
      favicon_url: this.faviconUrl,
      login_logo_url: this.loginLogoUrl,
      login_background_url: this.loginBackgroundUrl
    }
    this.systemService.setGlobalBranding(JSON.stringify(json)).subscribe((response) => {
      if(response.success) {
        this._snackBar.open('Branding successfully saved', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }
}
